import {
  employmentStatuses
} from './fieldOptions'

const translateAccountFieldsToContact = fields => fields.map((f) => {
  const normalizedName = f.replace(/person/, '')
  return normalizedName.charAt(0).toLowerCase() + normalizedName.substring(1)
})

export const personalInformationFields = [
  'firstName',
  'middleName',
  'lastName',
  'personBirthdate',
  'personBirthdateConfirmation',
  'billingStreet',
  'billingCity',
  'billingPostalCode',
  'billingState',
  'billingCountry',
  'personHomePhone',
  'personMailingStreet',
  'personMailingCity',
  'personMailingPostalCode',
  'personMailingState',
  'personMailingCountry',
  'personMobilePhone',
  'personEmail',
]

export const trustContactFields = [
  'trustName',
  'dateOfTrust',
  'lastFourDigitTaxId',
  'taxIdentificationNumber'
]

export const organizationContactFields = [
  'organizationName',
  'lastFourDigitTaxId',
  'taxIdentificationNumber',
]

export const identityFields = [
  'identificationType',
  'identificationNumber',
  'localeOfIdIssuance',
  'identificationIssueDate',
  'identificationExpirationDate'
]

export const identityVerificationFields = [
  'ssn',
  'ssnConfirmation',
  'motherMaidenName',
  'countryOfResidence',
  'countryOfBirth',
  'primaryCitizenship'
]

export const allIdentityVerificationFields = [
  ...identityVerificationFields,
  ...identityFields,
]

export const employmentDetailsFields = [
  'employmentStatus',
  'finraAffiliated',
  'publicCompanyAffiliated'
]

export const employmentDetailsContingentFields = [
  'occupation',
  'currentEmployer',
  'personOtherStreet',
  'personOtherCity',
  'personOtherPostalCode',
  'personOtherState',
  'personOtherCountry',
  'personOtherPhone'
]

export const allEmploymentDetailsFields = [
  ...employmentDetailsFields,
  ...employmentDetailsContingentFields,
]

const nonRequiredIdentityFields = (input) => {
  const { primaryCitizenship } = input
  if (primaryCitizenship === 'United States') {
    return identityFields
  } else {
    return []
  }
}

const employmentStatusValues = employmentStatuses.map(s => s.value)
const nonRequiredEmploymentFields = (input, forAccount = true) => {
  const { employmentStatus } = input
  if (!employmentStatusValues.includes(employmentStatus)) {
    return forAccount ?
      employmentDetailsContingentFields :
      translateAccountFieldsToContact(employmentDetailsContingentFields)
  } else {
    return []
  }
}

export const nonRequiredContingentFields = (input, forAccount = true) => {
  const identity = nonRequiredIdentityFields(input)
  const employment = nonRequiredEmploymentFields(input, forAccount)
  return [...identity, ...employment]
}

export const associateContactFields = translateAccountFieldsToContact([
  ...personalInformationFields.filter(f => !/billing/.test(f)),
  ...allIdentityVerificationFields,
  ...allEmploymentDetailsFields
])

export const allContactFields = [
  ...associateContactFields,
  ...trustContactFields,
  ...organizationContactFields,
  'recordTypeId',
  'deceased',
  'lastFourDigitIdentificationNumber',
  'dateOfDeath',
  'countryOfIncorporation',
  'stateOfIncorporation',
  'relationship',
]

export const personalAccountDetailsFields = [
  'paperlessDelivery',
  'donorFirstName',
  'donorMiddleName',
  'donorLastName',
  'donorSocialSecurityNumber',
  'donorDateOfBirth',
  'donorPhone',
  'donorAddress',
  'donorCity',
  'donorState',
  'donorZipCode',
  'donorCountry',
  'donorEmail',
  'donorOccupation',
  'dateOfDeath',
  'donorAdvisedFundName',
  'anotherDonor',
  'deceasedFirstName',
  'deceasedMiddleName',
  'deceasedLastName',
  'deceasedDob',
  'deceasedSsn',
  'deceasedDod',
  'minorFirstName',
  'minorMiddleName',
  'minorLastName',
  'minorDateOfBirth',
  'minorSsn',
  'minorAgeOfTermination',
]

export const employerInformationFields = [
  'employerCity',
  'employerCountry',
  'employerEffectiveDateConfiguration',
  'employerFiscalYearEndDay',
  'employerFiscalYearEndMonth',
  'employerIdentificationNumber',
  'employerName',
  'employerPhone',
  'employerPlanEffectiveDate',
  'employerPostalCode',
  'employerPriorPlanEffectiveDate',
  'employerState',
  'employerStreetAddress',
  'employerIncomeTaxDate',
  'employerPlanName',
  'employerTypeOfBusiness',
]

export const trustDetailsFields = [
  'trustName',
  'dateOfTrust',
  'taxIdentificationNumber',
  'trustGovernedInStateOf',
  'publicCompanyAffiliated',
  'lastFourDigitTaxId',
  'paperlessDelivery',
  'irrevocableTrustType',
  'decedentFirstName',
  'decedentLastName'
]

export const additionalDetailsFields = [
  'sepApproveDefaultAdditionalDetails',
  'sepPlanServiceRequirement',
  'sepPlanServiceRequirementDetails',
  'sepPlanAgeRequirement',
  'sepEmployedAsOfEffectiveDate',
  'sepEligibleClassParticipantsA',
  'sepEligibleClassParticipantsB',
  'sepEligibleClassParticipantsC',
  'sepEligibleClassParticipantsD',
  'sepContributionFormula',
  'sepContributionFormulaPercentage',
  'sepContributionFormulaDollar',
  'sepAllocationFormula',
  'sepIntegratedFormulaLevelPercentage',
  'sepTopHeavyMinimumAllocation',
  'sepTopHeavyMinimumAllocationName',
  'sepCompensationElections',
  'sepPlanYearElections',
  'sepPlanYearElectionsCustomPeriod',
  'sepElectiveDeferralDollar',
  'sepElectiveDeferralPercentage',
  'sepAllowSeparateDeferral',
  'sepCatchUpContributionsPermitted',
  'simpleApproveDefaultAddtlDetails',
  'simpleCatchUpContributionsPermitted',
  'simpleCurrentYearCompAmount',
  'simpleEligibilityServiceRequirement',
  'eligibilityServiceRequirement',
  'eligibilityServiceRequirementMonths',
  'eligibilityServiceRequirementYears',
  'simpleEligibleClassParticipantsA',
  'simpleEligibleClassParticipantsB',
  'simpleEligibleClassParticipantsC',
  'simpleMinCompForEmployerContrib',
  'simpleModificationElectionPeriods',
  'simplePriorYearCompAmount',
  'simplePriorYearCompYears'
]

export const sanitizeInputs = (inputs, fieldList) => {
  const keys = Object.keys(inputs)

  keys.forEach((k) => {
    if (!fieldList.includes(k)) {
      delete inputs[k]
    }
  })
  return inputs
}

// formData must be an object
export const removeNullData  = (formData) => {
  const keys = Object.keys(formData)
  keys.forEach((k) => {
    if (!formData[k]) {
      delete formData[k]
    }
  })
  return formData
}

export default {
  personalInformationFields,
  identityVerificationFields,
  employmentDetailsFields,
  personalAccountDetailsFields,
  employerInformationFields,
  additionalDetailsFields,
  trustDetailsFields
}



// WEBPACK FOOTER //
// ./src/utils/formFieldLists.js